var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React from 'react';
import { IconSurgePremium as StencilIconSurgePremium } from '@amzn/atoz-web/Icons';
import { useTranslation } from 'react-i18next';
export var IconSurgePremium = function (props) {
    var t = useTranslation().t;
    return (React.createElement(StencilIconSurgePremium, __assign({ title: "".concat(t('shift_management_common_pay_premium')) }, props)));
};
